import { combine, withContext, withCallbacks } from 'react-hooks-combine'
import { StoreContext } from 'store/context'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'

import { withRouter } from 'react-router'
import AccountTokenCheckComponent from './component'
import { profile, auth as authRoutes } from '../../route.map'

export default combine({
  hocs: [withRouter],
  hooks: [
    withContext('appStore', StoreContext),
    withContext('auth', StoreContext, ({ auth }) => auth),

    withContext(
      'disposableTokensService',
      ServicesContext,
      ({ disposableTokensService }) => disposableTokensService
    ),
    withCallbacks(
      {
        onCheckTokenHash:
          ({ disposableTokensService, auth }, { history }) =>
          async (token, nonce) => {
            try {
              const userEntity = await disposableTokensService.getToken(
                token,
                nonce
              )
              await auth.setToken(userEntity)
              history.replace(profile.balance())
            } catch (e) {
              toaster.error(e.message)
              history.replace(authRoutes.login())
            }
          },
      },
      []
    ),
  ],
  transformProps: ({ match, onCheckTokenHash }) => {
    return {
      token: match.params.token,
      nonce: match.params.nonce,
      onCheckTokenHash,
    }
  },
})(AccountTokenCheckComponent)
